<template>
	<div class="setting-page">
			<div class="ft20 cl-main ftw600">房间列表</div>
			
			<div class="form-search-box mt20">
				<a-form layout="inline">
					<a-form-item label="所属门店">
						<div>
							<a-select style="width: 120px" placeholder="请选择" v-model="search.mendian_id">
								<a-select-option :value="0">请选择</a-select-option>
								<a-select-option :value="item.mendian_id" v-for="(item,index) in mendians" :key="index">{{item.name}}</a-select-option>
							</a-select>
						</div>
					</a-form-item>
					<a-form-item label="房间名称">
						<a-input v-model="search.keyword" placeholder="请输入房间名称"></a-input>
					</a-form-item>
					<a-form-item>
						<a-button @click="searchAct" type="primary">查询</a-button>
						<a-button @click="cancelAct" class="ml10">取消</a-button>
					</a-form-item>
				</a-form>
			</div>
			
			<div  class="mt20">
				<a-button type="primary"  @click="addAct">新增房间</a-button>
			</div>
			<div class="mt20">
					<div class="wxb-table-white">
						<a-table rowKey="room_id" :columns="columns" :pagination="pagination" @change="handleTableChange" :data-source="datas"
						 :loading="loading">

							<!-- <template slot="pois" slot-scope="record,index">
								<div>
									{{record.lat}}/{{record.lng}}
								</div>
							</template> -->

							<template slot="mendian_slot" slot-scope="text,record">
								{{text ? text.name : '-'}}
							</template>

							<template slot="is_use_slot" slot-scope="text,record">
								{{text == 1 ? '是' : '否'}}
							</template>

							<template slot="is_yin_slot" slot-scope="text,record">
								{{text == 1 ? '是' : '否'}}
							</template>

							<template slot="status_slot" slot-scope="text,record">
								{{text == 1 ? '正常' : '关闭'}}
							</template>

							<template slot="action" slot-scope="record,index">
								<div class="flex center">
									<a-dropdown placement="bottomRight">
										<span class="more-act">
											<i class="iconfont iconmore_gray"></i>
										</span>
										<a-menu slot="overlay">
											<a-menu-item>
												<a class="menu-act" href="javascript:;" @click="editAct(record)">
													<span>编辑房间</span>
												</a>
											</a-menu-item>
											
											<a-menu-item>
												<a class="menu-act" href="javascript:;" @click="delAct(record)">
													<span>删除房间</span>
												</a>
											</a-menu-item>
										
										</a-menu>
									</a-dropdown>
								</div>
							</template>

						</a-table>
					</div>
				</div>
			
			<div>
				<room-form v-if="showForm" @ok="formOk" @closed="formClosed" :datas="detail"></room-form>
			</div>
			
	</div>
</template>

<script>
import {
		listMixin
	} from '../../common/mixin/list.js';
	import roomForm from './components/room/form.vue';
	
	export default{
		mixins: [listMixin],
		components:{
			roomForm
		},
		computed:{
			// checkCanAdd(){
			// 	return  this.maxOpenNum > this.pagination.total;
			// }
		},
		data(){
			return {
				loading: false,
				showForm:false,
				detail:{
					room_id:0,
					name:'',
					room_no:'',
					mendian_id:0,
					room_desc:'',
					img_url:'',
					is_use:0,
					is_yin:0,
					is_project:0,
					status:1,
				},
				pagination: {
					current: 1,
					pageSize: 10, //每页中显示10条数据
					total: 0,
				},
				search: {
					keyword:'',
					mendian_id:0
				},
				maxOpenNum:0,
				columns: [
					{title: '房间ID',dataIndex: 'room_id',align: 'center'},
					{title: '房间名称',dataIndex: 'name',align: 'center'},
					{title: '房号',dataIndex: 'room_no',align: 'center'},
					{title: '所属门店',dataIndex: 'mendian',align: 'center',scopedSlots: {customRender: 'mendian_slot'}},
					{title: '介绍',dataIndex: 'room_desc',align: 'center'},
					{title: '使用中',dataIndex: 'is_use',align: 'center',scopedSlots: {customRender: 'is_use_slot'}},
					{title: '是否隐私',dataIndex: 'is_yin',align: 'center',scopedSlots: {customRender: 'is_yin_slot'}},
					{title: '状态',dataIndex: 'status',align: 'center',scopedSlots: {customRender: 'status_slot'}},
					{title: '操作',key: 'action',align: 'center',scopedSlots: {customRender: 'action'}},
				],
				datas: [],
				mendians: []
			}
		},
		created(){
			this.getLists();
			this.getMendians();
		},
		methods:{
			getMendians(){
				this.$http.api('admin/getAllMendian').then(res=>{
					this.mendians = res.mendian;
				}).catch(res=>{
					console.log(res);
				});
			},
			addAct(){
				/*if(this.checkCanAdd){
					this.detail = {
						mendian_id:0,
						name:'',
						tel:'',
						lng:'',
						lat:'',
						address:'',
					}
					this.showForm = true;
				}else{
					this.$error({
					        title: '错误提示',
					        content: '您可最多可创建'+this.maxOpenNum+'个门店',
					});
				}*/
				this.detail = {
					room_id:0,
					name:'',
					room_no:'',
					mendian_id:0,
					room_desc:'',
					img_url:'',
					is_use:0,
					is_yin:0,
					is_project:0,
					status:1,
				}
				this.showForm = true;
			},
			editAct(res){
				this.detail = res;
				this.showForm = true;
			},
			formOk(){
				this.showForm = false;
				this.getLists();
			},
			formClosed(){
				this.showForm = false;
			},
			delAct(record){
				this.$confirm({
					title:'确认删除这个房间吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('admin/delRoom',{
								room_id:record.room_id,
							}).then(res=>{
								this.$message.success('删除成功');
								this.getLists();
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
			getLists(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/getRoomList',{
					keyword:this.search.keyword,
					mendian_id:this.search.mendian_id,
					limit:this.pagination.pageSize,
					page:this.pagination.current,
				}).then(res=>{
					this.pagination.total=res.total;
					this.datas=res.list;
					this.maxOpenNum = res.store_num;
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
				})
			},
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current;
				this.getLists();
			},
			searchCancel() {
				this.search = {
					keyword:'',
				};
			},
			searchAct(){
				this.getLists();
			},
			cancelAct(){
				this.searchCancel();
				this.searchAct();
			}
		
		}
	}
</script>

<style>
	.setting-page{
		min-width: 1080px;
	}
</style>